import * as MODULES from '../module-codes'
import axios from 'axios'

export const state = () => ({
})

export const getters = {
}

export const actions = {
}

export const mutations = {
}
